import { Typography } from '@mui/material';
import Sagemaker from '../../assets/images/Sagemmaker.png';
import Lambda from '../../assets/images/Lambda.png';
import AgentCore from '../../assets/images/bedrock-agentcore.png';
import Bucket from '../../assets/images/bucket.png';
import Salesforce from '../../assets/images/Salesforce.png';
import DynamoDb from '../../assets/images/dynamo-db.png';
import Polly from '../../assets/images/polly.png';
import cloudSearch from '../../assets/images/cloud-search.png';

export const Screen5Generating = () => {
  const awsServices = [
    { name: 'AWS Sagemaker', image: Sagemaker },
    { name: 'Amazon Lambda', image: Lambda },
    { name: 'Amazon Bedrock Agent-core', image: AgentCore },
    { name: 'Amazon S3 Bucket', image: Bucket },
    { name: 'Salesforce', image: Salesforce },
    { name: 'Amazon DynamoDb', image: DynamoDb },
    { name: 'AWS Polly', image: Polly },
    { name: 'Amazon CloudSearch', image: cloudSearch },
  ];

  return (
    <div className="p-6 h-full flex flex-col ">
      <div className="grid grid-cols-2 ">
        {awsServices.map((service, index) => (
          <div key={index} className="flex items-center justify-center mb-5">
            <img
              src={service.image}
              alt={service.name}
              className="w-24 h-24 object-contain rounded-md"
              onError={e => {
                console.error(`Failed to load image: ${service.name}`, service.image);
                e.target.style.display = 'none';
                const fallback = document.createElement('div');
                fallback.className =
                  'text-xs font-semibold text-gray-700 text-center border rounded-lg p-2 w-full h-full flex items-center justify-center';
                fallback.textContent = service.name
                  .split(' ')
                  .map(word => word[0])
                  .join('')
                  .replace('A', '')
                  .substring(0, 3);
                e.target.parentNode.appendChild(fallback);
              }}
            />
          </div>
        ))}
      </div>
      <Typography fontSize={21} textAlign="center">
        Generating your personalized
        <br />
        executive pitch. This will only
        <br />
        take a few moments.
      </Typography>
    </div>
  );
};
